// extracted by mini-css-extract-plugin
export default {"btn-add-todo":"AddTodo_btn-add-todo__2RSE+"};